/**
 * useAppBadge — Sets/clears the app icon badge via the Badging API.
 *
 * Android (Chrome 81+) and ChromeOS show a numeric dot on the home screen icon.
 * The API is also available on macOS Safari/Chrome but not iOS.
 *
 * Convention used here:
 *   RUNNING  → badge = 1 (retreat is live)
 *   IDLE     → badge cleared
 *   Other    → no change
 */
import { useEffect } from "react";
import { RetreatState } from "@retreats/engine";

export function useAppBadge(status: RetreatState): void {
  useEffect(() => {
    if (!("setAppBadge" in navigator)) return;

    if (status === RetreatState.RUNNING) {
      navigator.setAppBadge(1).catch(() => {});
      // Only register cleanup when we actually set the badge.
      // An unconditional cleanup would clear the badge on RUNNING → PAUSED even
      // though the contract says "Other → no change".
      return () => { navigator.clearAppBadge().catch(() => {}); };
    }
    if (status === RetreatState.IDLE) {
      navigator.clearAppBadge().catch(() => {});
    }
  }, [status]);
}
